import { hoyCL } from "@/lib/fecha";
// Lectura del QR de la cédula de identidad chilena (Registro Civil).
// El QR trae: RUN, nº de serie y un MRZ con la fecha de nacimiento y el vencimiento.
// Ejemplo: https://portal.sidiv.registrocivil.cl/docstatus?RUN=14482949-2&type=CEDULA
//          &serial=521616097&mrz=521616097780061783006173
// Los lectores emulan teclado, así que algunos símbolos llegan cambiados: el parseo es tolerante.
import { normalizeRut } from "./rut";

export function esCedula(texto) {
  const s = String(texto || "").toUpperCase();
  return s.includes("RUN") && (s.includes("MRZ") || s.includes("SERIAL") || s.includes("DOCSTATUS"));
}

const fecha = (anio, mm, dd) => {
  const d = new Date(Date.UTC(anio, mm - 1, dd));
  if (d.getUTCMonth() + 1 !== mm || d.getUTCDate() !== dd) return null;
  return d.toISOString().slice(0, 10);
};

export function calcularEdad(nacimiento) {
  if (!nacimiento) return null;
  const n = new Date(`${String(nacimiento).slice(0, 10)}T00:00:00`);
  if (isNaN(n.getTime())) return null;
  const h = new Date();
  let e = h.getFullYear() - n.getFullYear();
  const antes = h.getMonth() < n.getMonth() || (h.getMonth() === n.getMonth() && h.getDate() < n.getDate());
  return antes ? e - 1 : e;
}

/** Devuelve { tipo, rut, serial, nacimiento, vence, edad, vigente } o null si no es cédula. */
export function parseCedula(texto) {
  const s = String(texto || "");
  if (!esCedula(s)) return null;
  const mr = s.match(/RUN\W{0,3}(\d{6,9})\W{0,3}([0-9kK])/i);
  const rut = mr ? normalizeRut(`${mr[1]}-${mr[2]}`) : null;
  if (!rut) return null;
  let serial = (s.match(/serial\W{0,3}(\d{6,12})/i) || [])[1] || null;
  let nacimiento = null, vence = null;
  const mz = (s.match(/mrz\W{0,3}(\d{20,30})/i) || [])[1];
  if (mz && mz.length >= 24) {
    serial = serial || mz.slice(0, 9);
    const anioActual = new Date().getFullYear();
    const nyy = +mz.slice(10, 12), nmm = +mz.slice(12, 14), ndd = +mz.slice(14, 16);
    const vyy = +mz.slice(17, 19), vmm = +mz.slice(19, 21), vdd = +mz.slice(21, 23);
    nacimiento = fecha(2000 + nyy <= anioActual ? 2000 + nyy : 1900 + nyy, nmm, ndd);
    vence = fecha(2000 + vyy >= anioActual - 15 ? 2000 + vyy : 1900 + vyy, vmm, vdd);
  }
  return {
    tipo: "CEDULA", rut, serial, nacimiento, vence,
    edad: calcularEdad(nacimiento),
    vigente: vence ? vence >= hoyCL() : null,
  };
}

/** Acepta un RUT tecleado o el escaneo completo de la cédula. */
export function parseRutOCedula(texto) {
  const ced = parseCedula(texto);
  if (ced) return ced;
  const rut = normalizeRut(texto);
  return rut ? { tipo: "RUT", rut, nacimiento: null, edad: null } : { tipo: "DESCONOCIDO", rut: null };
}
